import React from 'react';
import { IndexCoordinatorDelegate } from "../IndexCoordinator";
import { PendencyReasonViewControllerDelegate, PendencyReasonViewController } from "../../Screen/PendencyReason/PendencyReasonViewController";
import { TableGenericViewControllerDelegate, TableGenericViewController } from "../../Screen/TableGeneric/TableGenericViewController";
import { TableGenericViewModel } from "../../Screen/TableGeneric/TableGenericViewModel";
import { PendencyReasonViewModel } from '../../Screen/PendencyReason/PendencyReasonViewModel';
import ProtectedRoute from '../../Components/ProtectedRoute';

export class PendencyReasonCoordinator implements IndexCoordinatorDelegate, PendencyReasonViewControllerDelegate, TableGenericViewControllerDelegate {

    getRoute(): JSX.Element[] {
        return [
            this.routeTable(),
            this.routeForm()
        ]
    }

    private routeTable(): JSX.Element {
        var viewModel = new TableGenericViewModel("gepdenguependencia")
        return (<ProtectedRoute requiredPermissions={['dengue.pendencia.*']} path="/:base/dengue/pendencia" exact={true} component={(props: any) => {
            return (<TableGenericViewController
                permissions={{
                    add: 'dengue.pendencia.adicionar',
                    edit: 'dengue.pendencia.editar',
                    delete: 'dengue.pendencia.excluir',
                }}
                navigation={props}
                viewModel={viewModel}
                delegate={this}
                title={"Motivo Pendência"}
            />)
        }} />)
    }

    private routeForm(): JSX.Element {
        var viewModel = new PendencyReasonViewModel()
        return (<ProtectedRoute requiredPermissions={['dengue.pendencia.adicionar', 'dengue.pendencia.editar']} path="/:base/dengue/pendencia/cad/:id" exact={true} component={(props: any) => {
            var idPk = props.match.params.id
            return (<PendencyReasonViewController
                navigation={props}
                viewModel={viewModel}
                delegate={this}
                idPrimary={idPk}
            />)
        }} />)
    }

    tapDimiss(navigation: any): void {
        navigation.history.goBack();
    }

    add(navigation: any, viewModel: TableGenericViewModel): void {
        if (viewModel.getTable() == "gepdenguependencia") {
            navigation.history.push(`pendencia/cad/0`);
            return;
        }
    }

    edit(navigation: any, idSelection: number, viewModel: TableGenericViewModel): void {
        if (viewModel.getTable() == "gepdenguependencia") {
            navigation.history.push(`pendencia/cad/${idSelection}`);
            return;
        }
    }

}